import React, { HTMLAttributes, MouseEventHandler } from 'react';
import { IconType } from 'react-icons';

interface ButtonWithIconProps extends HTMLAttributes<HTMLDivElement> {
    onClick?: MouseEventHandler<HTMLDivElement>;
    text: string;
    icon: IconType;
}

const CircularButtonWithIcon: React.FC<ButtonWithIconProps> = ({
    onClick = () => { },
    className,
    icon: Icon,
    text,
    ...rest
}) => {
    return (
        <div className={`flex flex-col items-center gap-2 ${className ?? ''}`} {...rest}>
            <div
                className="flex items-center justify-center btn btn-primary btn-square rounded-full w-16 h-16 cursor-pointer"
                onClick={onClick}
                role="button"
                tabIndex={0}
                aria-label={text}
            >
                {Icon && <Icon className="w-6 h-6" />}
            </div>
            {text && <span className="text-sm font-semibold text-base-content/80 mt-1 text-center max-w-[80px] leading-tight">{text}</span>}
        </div>
    );
};

export default CircularButtonWithIcon;